import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import nrLogo from  "./assets/office.jpeg" 
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

export const Blogs = () => {
    const navigate = useNavigate();

     const [posts, setPosts] = useState([])

    // const [userA,setAd]=useState()
    //        const fetchUser = async () => {
    //         const { data: { user } } = await supabase.auth.getUser()
    //   setAd(user)
      
    // };
    
useEffect(() => {
    async function fetchPosts() {
      const { data, error } = await supabase
        .from('posts')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(3);

      if (error) {
        console.error('Error fetching posts:', error)
      } else {
        setPosts(data)
      }
    }

    fetchPosts()
  }, [])

//   if (loading) return <p>Loading posts...</p>
    if (!posts.length) return <p className='text-center '></p>    
      

    const { language } = useLanguage();
    const t = translations[language].blog;

    const blogs = t.posts.map(post => ({
        ...post,
        image: `/images/blog${post.id}.jpg`
    }));
function moveTo(id){
console.log(id)
    navigate(`/blogs/${id}`)
}
    return (
        <section id="blogs" className="py-16 bg-gray-50">
          <div className="container mx-auto px-6">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold text-gray-800 mb-4">{t.title}</h2>
                    <p className="text-gray-600">{t.subtitle}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {posts?.map((blog) => (
                        <div  onClick={()=>navigate(`/blogs/${blog?.id}`)}  key={blog.id} className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform duration-300 hover:transform hover:scale-105">
                            <div className="relative h-48">
                                <img 
                                src={blog.image_url}
                                    alt={blog.title}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="p-6">
                                <div className="text-sm text-gray-500 mb-2">{blog.date}</div>
                                <h3 className="text-xl font-semibold text-gray-800 mb-3">{blog.title}</h3>
                                <p className="text-gray-600 mb-4">{blog.content}</p>
                                <button onClick={()=>moveTo(blog.id)} className="text-primary hover:text-primary-dark transition-colors duration-300">
                                    {t.readMore} →
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
